import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { MemberByInvitation } from './service/add-member-by-invitation.service';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';
import { CommonHelper } from '../../../../utilities/common.helper';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { HEC_CONSTANTS } from '../../../../utilities/constants';


@Component({
  selector: 'kt-add-member-by-invitation',
  templateUrl: './add-member-by-invitation.component.html',
  styleUrls: ['./add-member-by-invitation.component.scss'],
  providers: [MemberByInvitation]
})
export class AddMemberByInvitationComponent implements OnInit {
  public form: FormGroup;
  public dropdownPanels:any = null
  public dropdownCategories:any = null
  public dropdownMajor:any = null
  public dropdownInstitute:any = null
  public dropdownCategoryTypes = HEC_CONSTANTS.DROPDOWN_CATEGORY_TYPE
  public pageState:any = null

  public isDataPresent:boolean = true

  public EMAIL_REGEX = CommonHelper.EMAIL_REGEX;
  public MOBILE_REGEX = CommonHelper.MOBILE_REGEX;
  public SearchCountryField = SearchCountryField;
	// public TooltipLabel = TooltipLabel;
	public CountryISO = CountryISO;

  public filteredMajors: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredInstitutions: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();

  constructor(private dialogRef: MatDialogRef<AddMemberByInvitationComponent>,
              private fb: FormBuilder,
              private sharedService: SharedService,
              private memberByInvitationService:MemberByInvitation,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {}
    
  ngOnInit() {

    this.createForm()
    this.pageState = this.data.pageState
    this.setPanelType()
  }


  //Conditional Functions Starts =========
 
  private createForm(): void {
    this.form = this.fb.group({
      categoryName: [''],
      email: ['', Validators.required],
      contactNumber:[''],
      fullName:['',Validators.required],
      batchId:[null],
      subBatchId:[null],
      panelName: [null],
      panelId:[null],
      panelTypeCodeId:[null],
      disciplinaryCategoryName:[null],
      majorSubjectId:[null],
      minorSubject:[null],
      instituteId:[null],
      majorFilter:[null],
      instituteFilter:[null]
    })
  }

  private markFormsTouched(): void {
    CommonHelper.markFormGroupTouched(this.form);
  }

  private formValid(payload): boolean {
    return this.form.valid && payload.rgaRoleViewDtoList.length > 0
  }

  private constructPayload():any {
    var rgaRoleViewDtoList = []
       let obj = {
        batchId: this.data.batchId,
        subBatchId:this.data.grantId,
        fullName:this.form.value.fullName,
        panelName:this.form.value.panelName,
        panelId:this.form.value.panelId ? this.form.value.panelId : null,
        categoryName:this.form.value.categoryName,
        email:this.form.value.email,
        contactNumber:this.form.value.contactNumber.internationalNumber,   
    
       }
      rgaRoleViewDtoList.push(obj)
    
    let payload = {
    
        panelId:this.data.panelData.panelId ? this.data.panelData.panelId : null,
        panelName:this.data.panelData.panelName ? this.data.panelData.panelName : null,
        rgaRoleViewDtoList: rgaRoleViewDtoList,
        addMajorMinorSubject : false
    }

    for(let i=0;i<payload.rgaRoleViewDtoList.length;i++){ 
      payload.rgaRoleViewDtoList[i].majorSubjectId = this.form.value.majorSubjectId ? this.form.value.majorSubjectId : null
      payload.rgaRoleViewDtoList[i].minorSubject = this.form.value.minorSubject ? this.form.value.minorSubject : null
      payload.rgaRoleViewDtoList[i].instituteId = this.form.value.instituteId ? this.form.value.instituteId : null
      if(payload.rgaRoleViewDtoList[i].majorSubjectId)
      {
        payload.rgaRoleViewDtoList[i].majorSubject =  (this.dropdownMajor as any).find((v: any) => v.value ==  payload.rgaRoleViewDtoList[i].majorSubjectId).label

      }
     
      payload.addMajorMinorSubject = true
    }

    if(this.pageState == 'Thematic'){
      for(let i=0;i<payload.rgaRoleViewDtoList.length;i++){      
        payload.rgaRoleViewDtoList[i].disciplinaryCategoryName = this.form.value.disciplinaryCategoryName ? this.form.value.disciplinaryCategoryName : null
      }
    }
    else if(this.pageState == 'Disciplinary'){
      for(let i=0;i<payload.rgaRoleViewDtoList.length;i++){      
        payload.rgaRoleViewDtoList[i].categoryName = this.form.value.disciplinaryCategoryName ? this.form.value.disciplinaryCategoryName : null
      }
    }
    else{

    }
   
    return payload;
  }

  private constructPayloadForAdministrativePanel():any{
    var rgaRoleViewDtoList = []
    let obj = {
     batchId: this.data.batchId,
     subBatchId:this.data.grantId,
     fullName:this.form.value.fullName,
     panelName : this.data.panelData.panelName,
     email:this.form.value.email ? this.form.value.email : null,
     categoryName:this.data.panelData.panelName,
     contactNumber:this.form.value.contactNumber.internationalNumber ? this.form.value.contactNumber.internationalNumber : null,
     
    }
   rgaRoleViewDtoList.push(obj)

    let payload = {
    panelName:this.data.panelData.panelName,
    rgaRoleViewDtoList: rgaRoleViewDtoList
  }
  return payload
  }

  private constructPayloadForJMP():any{
    var rgaRoleViewDtoList = []
       let obj = {
        batchId: this.data.batchId,
        subBatchId:this.data.grantId,
        fullName:this.form.value.fullName,
        panelName:this.form.value.panelName,
        panelId:this.form.value.panelId ? this.form.value.panelId : null,
        categoryName:this.form.value.categoryName,
        email:this.form.value.email,
        contactNumber:this.form.value.contactNumber.internationalNumber,      
       }
      rgaRoleViewDtoList.push(obj)
    
    let payload = {   
        rgaRoleViewDtoList: rgaRoleViewDtoList,
        addMajorMinorSubject : false
    }
    for(let i=0;i<payload.rgaRoleViewDtoList.length;i++){ 
      payload.rgaRoleViewDtoList[i].disciplinaryCategoryName = this.form.value.disciplinaryCategoryName ? this.form.value.disciplinaryCategoryName : null
      payload.rgaRoleViewDtoList[i].majorSubjectId = this.form.value.majorSubjectId ? this.form.value.majorSubjectId : null
      payload.rgaRoleViewDtoList[i].minorSubject = this.form.value.minorSubject ? this.form.value.minorSubject : null
      payload.rgaRoleViewDtoList[i].instituteId = this.form.value.instituteId ? this.form.value.instituteId : null
      
      if(payload.rgaRoleViewDtoList[i].majorSubjectId)
      {
        payload.rgaRoleViewDtoList[i].majorSubject =  (this.dropdownMajor as any).find((v: any) => v.value ==  payload.rgaRoleViewDtoList[i].majorSubjectId).label

      }    
      payload.addMajorMinorSubject = true
    }
    return payload;
  }
  
  public addMembers(): void {
    this.markFormsTouched();
    var payload = null
    if (this.pageState == 'Administrative') {
      payload = this.constructPayloadForAdministrativePanel()
      if (!this.formValid(payload))
        return;
      this.isDataPresent = false
      this.addAdministrativeDataToService(payload)
    }
    else if (this.pageState == 'Thematic' || this.pageState == 'Disciplinary') {
      payload = this.constructPayload()
      if (!this.formValid(payload))
        return;
      this.isDataPresent = false
      this.addDataToService(payload)
    }
    else if(this.pageState == 'JMP'){
      payload = this.constructPayloadForJMP()
      if (!this.formValid(payload))
      return;
    this.isDataPresent = false
    this.addJMPDataToService(payload)
    }
    else if(this.pageState == 'Steering Committee'){
      payload = this.constructPayloadForJMP()
      if (!this.formValid(payload))
      return;
    this.isDataPresent = false
    this.addSteeringCommitteeDataToService(payload)
    }
    else if(this.pageState == 'HLEP'){
      payload = this.constructPayloadForJMP()
      if (!this.formValid(payload))
      return;
    this.isDataPresent = false
    this.addHLEPDataToService(payload)
    }
    else {
    }
    
  }

  public findPanelId(value):void{
    let panelName = (this.dropdownPanels as any).find((v: any) => v.value == +value).label;
    if (panelName)
      this.form.controls.panelName.setValue(panelName);
  }

  public keyPress(event){  
        CommonHelper.keyPress(event)   
  }

  public onButtonClick(button?) {
      this.dialogRef.close(button);
  }

  public showRoleDropdown():boolean{
    return (this.pageState == 'Thematic' || this.pageState == 'JMP' 
            || this.pageState == 'HLEP' || this.pageState == 'Steering Committee')
  }

  private setPanelType(): void {
    if (this.pageState == 'Administrative') { 
    }
    else if (this.pageState == 'Disciplinary') {
      this.form.controls.disciplinaryCategoryName.setValidators(Validators.required)
      this.getMajorList()
      this.getInstitutionList()

    }
    else if(this.showRoleDropdown()){
      this.getPanelsList(this.data.grantId)
      this.getCategoryList(this.data.panelData.panelId ? this.data.panelData.panelId : 0)
      this.getMajorList()
      this.getInstitutionList()
      this.form.controls.panelId.setValidators(Validators.required)
      this.form.controls.categoryName.setValidators(Validators.required)
      this.form.controls.disciplinaryCategoryName.setValidators(Validators.required)
    }
  }
  
    
  
  //Service Functions Starts ========


  private addDataToService(payload):void{
    this.memberByInvitationService.addAndInviteMember(payload)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
        else {
          payload.rgaRoleViewDtoList[0].isInvited = true
          this.dialogRef.close({payload,res})
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } 
        else {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        }
      }

    )
  }

  private addAdministrativeDataToService(payload):void{
    this.memberByInvitationService.addAndInviteMemberAdministrative(payload)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
        else {
          payload.rgaRoleViewDtoList[0].isInvited = true
          this.dialogRef.close({payload,res})
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } 
        else {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        }
      }

    )
  }

  private addJMPDataToService(payload):void{
    this.sharedService.addAndInviteJMPMember(payload)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
        else {
          payload.rgaRoleViewDtoList[0].isInvited = true
          this.dialogRef.close({payload,res})
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } 
        else {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        }
      }

    )
  }
  
  private addSteeringCommitteeDataToService(payload):void{
    this.sharedService.addAndInviteSteeringCommitteeMember(payload)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
        else {
          payload.rgaRoleViewDtoList[0].isInvited = true
          this.dialogRef.close({payload,res})
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } 
        else {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        }
      }

    )
  }

  private addHLEPDataToService(payload):void{
    this.sharedService.addAndInviteHLEPMember(payload)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
        else {
          payload.rgaRoleViewDtoList[0].isInvited = true
          this.dialogRef.close({payload,res})
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } 
        else {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        }
      }
    )
  }
  
  private getCategoryList(panelId) {
    this.sharedService.getCategoryListForTeamManagement(panelId).subscribe(
      (response: any) => {
        if (response && response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.dropdownCategories = response['data']
        }
        else {
          this.dropdownCategories = []
          this.sharedService.showError(response.statusDescription, 'OK', 'error-snackbar');
        }
      },
      (err) => {
        this.dropdownCategories = []
        this.sharedService.showError(err.error, 'OK', 'error-snackbar');
      })
  }

  private getPanelsList(grantId) {
    this.sharedService.getPanelsListForTeamManagement(grantId).subscribe(
      (response: any) => {
        if (response && response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.dropdownPanels = response['data']
        }
        else {
          this.dropdownPanels = []
          this.sharedService.showError(response.statusDescription, 'OK', 'error-snackbar');
        }
      },
      (err) => {
        this.dropdownPanels = []
        this.sharedService.showError(err.error, 'OK', 'error-snackbar');
      })
  }

  private getMajorList() {
    this.sharedService.getMajorList().subscribe(response => {
      if (response) {
        this.dropdownMajor = response['data']
        this.filteredMajors.next(this.dropdownMajor.slice());
        this.form.controls.majorFilter.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterMajors();
        });
      }
      else{
        this.dropdownMajor = []
        
      }
    })
  }

  private getInstitutionList() {
    this.sharedService.getInstituteList().subscribe(response => {
      if (response) {
        this.dropdownInstitute = response['data']
        this.filteredInstitutions.next(this.dropdownInstitute.slice());
        this.form.controls.instituteFilter.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterInstitutes();
        });
    
      }
      else{
        this.dropdownInstitute = []
      }
    })
  }

  protected filterMajors() {
    if (!this.dropdownMajor) {
      return;
    }
    // get the search keyword
    let search = this.form.controls.majorFilter.value;
    if (!search) {
      this.filteredMajors.next(this.dropdownMajor.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredMajors.next(
      this.dropdownMajor.filter(member => (
        
        (member.label ? member.label.toLowerCase().indexOf(search) > -1 : null))))
  }

  protected filterInstitutes() {
    if (!this.dropdownInstitute) {
      return;
    }
    // get the search keyword
    let search = this.form.controls.instituteFilter.value;
    if (!search) {
      this.filteredInstitutions.next(this.dropdownInstitute.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredInstitutions.next(
      this.dropdownInstitute.filter(member => (
        
        (member.label ? member.label.toLowerCase().indexOf(search) > -1 : null))))
  }


}
